import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  CircularProgress,
  Box,
  Container,
} from "@mui/material";
import api from "../../globals/axios";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../components/Alert";
import UserCampaignCard from "../../components/Custom/UserCampaignCard";

const RegisteredCampaigns = () => {
  const { t } = useTranslation();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlert();
  const [expandedCampaignId, setExpandedCampaignId] = useState(null);

  const isAuthenticated = Boolean(localStorage.getItem("auth"));

  const fetchSignedupCampaigns = async () => {
    try {
      const response = await api.get("/leadgeneration/get-signup-campaigns");
      setCampaigns(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching active campaigns:", err);
      showAlert("Failed to fetch active campaigns", "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchSignedupCampaigns();
    } else {
      setLoading(false);
    }
  }, []);

  const handleViewDocument = (documentUrl) => {
    if (documentUrl) {
      window.open(documentUrl, "_blank");
    }
  };

  // Toggle expanded card
  const handleCardClick = (campaignId) => {
    setExpandedCampaignId((prevId) =>
      prevId === campaignId ? null : campaignId
    );
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Grid container mt={1}>
        {campaigns.length === 0 ? (
          <Container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80vh",
              textAlign: "center",
            }}
          >
            {isAuthenticated ? (
              <Typography>{t("No Registered Campaigns found")}</Typography>
            ) : (
              <Typography>
                {t(
                  "Please Login to see all the campaigns you have registered for"
                )}
              </Typography>
            )}
          </Container>
        ) : (
          campaigns.map((campaign) => (
            <UserCampaignCard
              key={campaign.campaign.id}
              campaign={campaign.campaign}
              isExpanded={expandedCampaignId === campaign.campaign.id}
              onCardClick={handleCardClick}
              onViewDocument={handleViewDocument}
            />
          ))
        )}
      </Grid>
    </>
  );
};

export default RegisteredCampaigns;
